import React from "react";

const FeedbackCheckIcon = ({ style = {} }) => {
  return (
    <svg style={style} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="26" height="26" rx="13" fill="#ECFDF3" />
      <rect x="1" y="1" width="26" height="26" rx="13" stroke="#F6FEF9" strokeWidth="2" />
      <path
        d="M23 14C23 9.02908 18.9709 5 14 5C9.02908 5 5 9.02908 5 14C5 18.9699 9.02908 23 14 23C18.9709 23 23 18.9699 23 14Z"
        stroke="#12B76A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 12L13.6247 16L11 13.6004"
        stroke="#12B76A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FeedbackCheckIcon;
